/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiResponseListAgentContextDocumentDto } from '../../models/api-response-list-agent-context-document-dto';

export interface ListContextDocuments$Params {
  'x-api-requestId': string;
  'x-api-canal': string;
  companyId: string;
}

export function listContextDocuments(http: HttpClient, rootUrl: string, params: ListContextDocuments$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseListAgentContextDocumentDto>> {
  const rb = new RequestBuilder(rootUrl, listContextDocuments.PATH, 'get');
  if (params) {
    rb.header('x-api-requestId', params['x-api-requestId'], {});
    rb.header('x-api-canal', params['x-api-canal'], {});
    rb.path('companyId', params.companyId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApiResponseListAgentContextDocumentDto>;
    })
  );
}

listContextDocuments.PATH = '/v1/api/admin-ui/agent-context/{companyId}/documents';
